<template>
	<template v-if="item">
		<BaseMetaSeo :data="item" />
		<CmsBreadcrumbs v-if="item?.breadcrumbs" :items="item.breadcrumbs" class="cd-bc wrapper" :remove-last="true" :links="true" />
		<div class="cd-main wrapper" :class="{'loading': loadingItemData}">
			<div class="cd-col1">
				<!-- images -->
				<CatalogProductImages :item="item" :loading-item-data="loadingItemData" v-if="!mobileBreakpoint" />

				<!-- State -->
				<BaseUiAccordion v-if="item?.element_content_state" id="state">
					<BaseUiAccordionPanel id="state" active v-if="item?.element_content_state">
						<!-- product state -->
						<template #header><BaseCmsLabel code='tab_product_state_description' /></template>
						<template #body>
							<div class="cd-tab-content cd-tab-content-desc" v-interpolation v-html="item.element_content_state" />
						</template>
					</BaseUiAccordionPanel>
				</BaseUiAccordion>
				
				<!-- Attributes -->
				<BaseUiAccordion v-if="displayedAttributes?.length" id="cd-specs">
					<BaseUiAccordionPanel id="specs" active v-if="displayedAttributes?.length">
						<template #header><BaseCmsLabel code="tab_specs" /></template>
						<template #body>
							<div class="cd-tab-content cd-tab-attributes">
								<div v-for="(item, key) in displayedAttributes" :key="key" class="cd-tab-attribute">
									<div class="cd-tab-attribute-title">{{ item.title }}</div>
									<div class="cd-tab-attribute-desc">
										{{ item.values.join(', ') }}
										<template v-if="item.unit"> {{ item.unit }}</template>
									</div>
								</div>
							</div>
							<div v-if="Object.keys(itemsAttributes)?.length > 6" class="cd-tab-more cd-tab-more-attr" @click="showAttr = !showAttr">{{ showAttr ? labels.get('show_less') : labels.get('show_all') }}</div>
						</template>
					</BaseUiAccordionPanel>	
				</BaseUiAccordion>
				
				<!-- content (show only if syndicated content is not available) -->
				<BaseUiAccordion v-if="item.content && !(item?.check_lists?.['webcatalog_cs-lt'] || item?.check_lists?.['webcatalog_cs-lb'] || item?.check_lists?.['webcatalog_cs-fm'])" id="desc">
					<BaseUiAccordionPanel id="desc" active v-if="item?.content">
						<!-- description -->
						<template #header><BaseCmsLabel code='tab_product_description' /></template>
						<template #body>
							<div class="cd-tab-content cd-tab-content-desc">
								<BaseUiToggleContent :content="item.content" :limit="1000" v-slot="{content, contentLength, active, onToggle}">
									<div v-html="content" v-interpolation />
									<div v-if="contentLength > 1000" class="cd-tab-more cd-tab-more-attr" @click="onToggle">{{ active ? labels.get('show_less') : labels.get('show_all')}}</div>
								</BaseUiToggleContent>
							</div>
						</template>
					</BaseUiAccordionPanel>
				</BaseUiAccordion>

				<!-- manufacturer description -->
				<BaseUiAccordion class="cd-tab cd-tab-desc" id="manufacturer-desc" v-if="item?.check_lists?.['webcatalog_cs-lt'] || item?.check_lists?.['webcatalog_cs-lb'] || item?.check_lists?.['webcatalog_cs-fm']">
					<BaseUiAccordionPanel id="state" active>
						<!-- product state -->
						<template #header><BaseCmsLabel code="tab_product_manufacturer_desc" /></template>
						<template #body>
							<div class="cd-tab-content cd-tab-syndicate" :class="{'active': toggleSyndicate}">
								<CatalogSyndicateContent :item="item" />
							</div>
							<div class="cd-tab-more cd-tab-more-attr" @click="toggleSyndicate = !toggleSyndicate">{{ toggleSyndicate ? labels.get('show_less') : labels.get('show_all')}}</div>
						</template>
					</BaseUiAccordionPanel>
				</BaseUiAccordion>				

				<div id="safety-info">
					<LazyCatalogProductSafetyInfo v-if="userInitialized" />
				</div>
				
				<div id="related">
					<ClientOnly>
						<LazyCatalogProductsWidget
							:fetch="{related_code: 'related', related_item_id: item.id, related_widget_data: item.related_widget_data, only_available: true, limit: 10, always_to_limit: true, response_fields: config.catalog.productsResponseFields}"
							:frosmo="item?.manufacturer_code == 'dyson-9231' ? 'cd_p1_brand_dyson' : 'cd_p1'"
							thumb-preset="catalogEntry"
							v-slot="{items}"
							v-if="userInitialized">
							<div class="related-products" id="recommend" v-if="items?.length">
								<CmsSectionHeader>
									<BaseCmsLabel code="related_products" />
								</CmsSectionHeader>
								<UiSwiper
									name="relatedProducts"
									:options="{
										breakpoints: {
											1500: {
												slidesPerView: 4,
												slidesPerGroup: 4,
												spaceBetween: 24,
											},
											980: {
												slidesPerView: 2,
												slidesPerGroup: 2,
												spaceBetween: 24,
											},
											700: {
												slidesPerView: 2,
												spaceBetween: 12,
												slidesPerGroup: 2,
											},
											0: {
												slidesPerView: 1.5,
												spaceBetween: 12,
												slidesPerGroup: 1,
											},
										}
									}">
									<BaseUiSwiperSlide v-for="(item, index) in items" :key="item.id">
										<CatalogIndexEntry :item="item" :index="index" :add-to-cart="true" class="cp-related" />
									</BaseUiSwiperSlide>
								</UiSwiper>
							</div>
						</LazyCatalogProductsWidget>
					</ClientOnly>
				</div>
			
				<!--
				FIXME bundle proizvodi
				<CatalogProductBoughtTogether />
				-->

				<ClientOnly>
					<LazyCatalogProductFeedback v-if="item?.feedback_rate_widget && item?.feedback_rate_widget?.rates_votes > 0" :item="item" />
				</ClientOnly>
			</div>

			<div class="cd-col2">
				<div class="m-images">
					<CatalogProductImages :item="item" v-if="mobileBreakpoint" />
				</div>
				
				<CatalogProductContainer class="info" id="info">
					<div v-if="item.manufacturer_title" class="cd-brand">
						<NuxtLink :to="item.manufacturer_url_without_domain">{{ item.manufacturer_title }}</NuxtLink>
					</div>
					<h1 class="cd-title">{{ item.seo_h1 }}</h1>

					<!-- ratings/comments/code -->
					<div class="cd-info">
						<LazyBaseFeedbackRatesWidget v-if="item?.feedback_rate_widget && item?.feedback_rate_widget?.rates_votes > 0" :data="item.feedback_rate_widget" v-slot="{stars}">
							<div class="cd-rate-section">
								<div v-if="mobileBreakpoint" class="cd-rate-average">{{ Number(item.feedback_rate_widget.rates).toFixed(1) }}</div>
								<FeedbackStars class="cd-rate" :stars="stars" />
								<div v-if="!mobileBreakpoint" class="cd-rate-average">({{ Number(item.feedback_rate_widget.rates).toFixed(1) }})</div>
								<div class="cd-rate-votes" @click="scrollTo('#feedback', {offset: 100})">{{ item.feedback_rate_widget.rates_votes }} <template v-if="!mobileBreakpoint"><BaseCmsLabel code='review' /></template></div>
							</div>
						</LazyBaseFeedbackRatesWidget>
						<div class="cd-code"><BaseCmsLabel code="sku_code" />: {{ item.code }}</div>
					</div>

					<LazyCatalogProductBadges v-if="userInitialized" :item="item" :types="['discount', 'uau', 'uaump', 'condition', 'text']" class="cd-badges" />
					<ClientOnly>
						<div class="price-container">
							<CatalogProductPrice :item="item" class="cd-price" />
							<div v-if="installmentPrice" class="cd-price-installment">
								<strong>
									<BaseCmsLabel code="installments_price_text" :replace="[{'%PRICE%': formatCurrency(installmentPrice)}]" :strip-html="true" />
								</strong>
								<span @click="modal.open('flyout', {mode: 'installments', header: true, content: {installment_calculation: item.installments_calculation, installment_list: item.installments_list_data}})"><BaseCmsLabel code="installments_calculate" /></span>
							</div>
							<CatalogDynamicPrice :item="item" />
						</div>
					</ClientOnly>
					
					<LazyCatalogProductServices mode="badges" :item="item" hydrate-on-visible />
					<LazyCatalogProductServices :item="item" v-model="selectedServices" hydrate-on-visible />
					<LazyCatalogProductConfigurabile :item="item" hydrate-on-visible />
					<LazyCatalogProductStatus :item="item" class="cd-status" hydrate-on-visible />

					<ClientOnly>
						<template v-if="!item.temporary_unavailable && item.type != 'configurable'">
							<template v-if="item.is_available">
								<div class="cd-add-to-cart">
									<LazyBaseWebshopAddToCart v-slot="{onAddToCart, loading}" v-if="item.is_available" :data="{modalData: item, shopping_cart_code: item.shopping_cart_code, quantity: 1, services: selectedServices}">
										<button class="btn cd-btn-add" @click="onAddToCart(), gtmTrack('add_to_cart', {items: item})" :disabled="loading || (item.xxx && !isAdult)">
											<UiLoader v-if="loading" mode="dots" />
											<template v-else>
												<span v-if="item.status == 5"><BaseCmsLabel code="cd_add_to_shopping_cart_preorder" /></span>
												<BaseCmsLabel v-else code='cd_add_to_shopping_cart' tag="span" />
											</template>
										</button>
									</LazyBaseWebshopAddToCart>
								</div>
							</template>
							<LazyFeedbackNotificationForm v-if="!item.is_available && item.feedback_notification_widget && userInitialized" :itemStatus="item.status" />
						</template>
					</ClientOnly>

					<LazyCatalogProductSellerDisclaimer :item="item" hydrate-on-visible />
					<LazyCatalogProductExtraInfo :item="item" hydrate-on-visible />
				</CatalogProductContainer>

				<LazyCatalogCharger :item="item" hydrate-on-visible />

				<!-- shipping info -->
				<LazyCatalogProductShipping :item="item" hydrate-on-visible />

				<!-- Product conditions -->
				<!-- FIXME ispis dostupnih stanja s linkovima na te proizvode
				<CatalogProductConditions id="conditions" />
				-->

				<!-- sellers -->
				<LazyCatalogProductSellers :item="item" id="sellers" hydrate-on-visible />

				<!-- energy box -->
				<CatalogProductContainer class="icon energy cd-energy-container" id="energy" :class="{'flyout': item.energy_image_upload_path}" v-if="energyAttr?.length" @click="item.energy_image_upload_path && modal.open('flyout', {header: true, title: labels.get('energy_flyout_title'), headerIcon: 'energy', content: '<img src='+absolute(item?.energy_image_upload_path)+' />'})">
					<template #title><BaseCmsLabel code="energy_title" /></template>
					<template #content>
						<div class="cd-energy-content">
							<div class="cd-energy-item" v-for="energy in energyAttr" :key="energy.id">
								<span>
									<BaseUiImage v-if="energy.image_upload_path" :src="energy.image_upload_path" width="40" height="22" default="/images/no-image-50.jpg" :alt="energy.title" />
									<template v-else>{{ energy?.title }}</template>
								</span>
								<span>{{energy.attribute_title}}</span>
							</div>
						</div>
					</template>

				</CatalogProductContainer>

				<CatalogProductContainer v-if="item?.seller_code == '9999' && labels.get('companies_value') != 'companies_value'" id="b2b">
					<template #title><BaseCmsLabel code="companies_value" /></template>
					<template #content>
						<div class="companies" v-if="labels.get('companies_info') != 'companies_info'" v-html="labels.get('companies_info')"></div>
					</template>
				</CatalogProductContainer>
			</div>
			<CatalogAgeVerificationOverlay :item="item" class="cp-detail-age-verification" />
		</div>

		<!-- Related products -->
		<ClientOnly>
			<LazyCatalogProductsWidget
				:fetch="{related_code: 'related', related_item_id: item.id, related_widget_data: item.related_widget_data, only_available: true, limit: 10, always_to_limit: true, response_fields: config.catalog.productsResponseFields}"
				:frosmo="item?.manufacturer_code == 'dyson-9231' ? 'cd_p2_brand_dyson' : 'cd_p2'"
				v-if="userInitialized"
				thumb-preset="catalogEntry"
				v-slot="{items}">
				<div class="cw" v-if="items?.length">
					<div class="wrapper">
						<CmsSectionHeader>
							<BaseCmsLabel code="similar_products" />
						</CmsSectionHeader>
					</div>
					<UiSwiper
						name="relatedProducts2"
						:options="{
							breakpoints: {
								1350: {
									slidesPerView: 5,
									slidesPerGroup: 5,
									spaceBetween: 24,
								},
								1100: {
									slidesPerView: 4,
									slidesPerGroup: 4,
									spaceBetween: 24,
								},
								750: {
									slidesPerView: 3,
									slidesPerGroup: 3,
									spaceBetween: 12,
								},
								0: {
									slidesPerView: 1.5,
									slidesPerGroup: 1,
									spaceBetween: 12,
								}
							}
						}">
						<BaseUiSwiperSlide v-for="(item, index) in items" :key="item.id" class="slide">
							<CatalogIndexEntry :item="item" :index="index" />
						</BaseUiSwiperSlide>
					</UiSwiper>
				</div>
			</LazyCatalogProductsWidget>
		</ClientOnly>
	</template>
</template>

<script setup>
	const {userInitialized} = useUtils();
	const webshop = useWebshop();
	const config = useAppConfig();
	const endpoints = useEndpoints();
	const route = useRoute();
	const labels = useLabels();
	const {emit, bus} = useEventBus();
	const {generateThumbs} = useImages();
	const {scrollTo} = useDom();
	const {formatCurrency} = useCurrency();
	const {onMediaQuery, insertBefore, insertAfter, appendTo, prependTo} = useDom();
	const {getLastUrlSegment, absolute} = useUrl();
	const modal = useModal();
	const item = useState('product');
	const {openAgeModal, isAdult} = useAgeVerification();
	const {isLoyalty, installmentPrice, energyAttr} = useProductData(item);
	const selectedServices = ref([]);
	const {gtmTrack} = useGtmBB();

	onMediaQuery({
		query: '(max-width: 1100px)',
		enter: () => {
			prependTo('.btn-all-reviews', '.feedback .body')
		}
	});

	onMediaQuery({
		query: '(max-width: 980px)',
		enter: () => {
			appendTo('.cd-energy-container', '.cd-col1');
			appendTo('#b2b', '.cd-col1');
		}
	});

	//rwd
	const {mobileBreakpoint} = inject('rwd');

	// generate thumbnails
	async function imageThumbs() {
		return Promise.all([
			generateThumbs({
				data: item.value,
				preset: 'catalogDetail'
			}),
		]);
	}
	await imageThumbs();

	// If user is not adult, show age verification overlay once page is loaded
	onMounted(() => {
		if(item.value?.xxx && !isAdult.value) {
			openAgeModal(item.value);
		}

		gtmTrack('view_item', {
			items: item.value,
		});
	});

	/* 
		Filter out unwanted attributes. Group same attribute values into one attribute. Data structure:
		{
			"Boja": {
				"values": ["Crvena", "Zelena"],
				"unit": ""
			}
		}
	*/
	const itemsAttributes = computed(() => {
		if (!item?.value?.attributes) return null;

		return item.value.attributes.reduce((acc, attr) => {
			if (['attribute_badges', 'superbenefits', 'katalog-9001'].includes(attr.code)) return acc;

			const key = attr.attribute_title;
			if (!acc[key]) {
				acc[key] = { values: [], unit: attr.attribute_unit || '' };
			}
			acc[key].values.push(attr.title);
			return acc;
		}, {});
	});

	// Toggle between showing all attributes and only the first 6
	const showAttr = ref(false);
	const displayedAttributes = computed(() => {
		const attributesArray = Object.entries(itemsAttributes.value || {});
		if(!attributesArray.length) return null;

		if (showAttr.value) {
			return attributesArray.map(([title, value]) => ({ title, ...value }));
		} else {
			return attributesArray.slice(0, 6).map(([title, value]) => ({ title, ...value }));
		}
	});

	//manufacturer content
	const toggleSyndicate = ref(false);

	// configurabile items
	const webcatalog = '?check_lists='+config.catalog.fetch.check_lists;
	const advancedItem = ref(null);
	const advancedItemTitle = ref(null);
	const loadingItemData = ref(false);
	const confShopingCartCode = ref(null);

	function resetProductServices() {
		useState('productSelectedServices').value = [];
		useState('productSelectedInsurance').value = '';
	}

	watch(
		() => bus.value,
		async (newValue) => {
			//advanced item
			if (newValue.event === 'advancedItem') {
				advancedItem.value = newValue.data?.advancedItem;
				advancedItemTitle.value = newValue.data?.advancedItemTitle;
			}

			//conf item
			if(newValue.event === 'productUpdate') {
				loadingItemData.value = true;
				const offerShoppingCartCode = newValue.data[0] ? newValue.data[0] : confShopingCartCode.value;
				let ep = endpoints.get('_get_hapi_catalog_offer');
				ep = ep.replace('%CODE%', offerShoppingCartCode);

				const res = await useApi(`${ep + webcatalog}`);
				if(res.data?.id) {
					item.value = res.data;

					//update url item code
					const url = new URL(window.location.href);
					const searchParams = new URLSearchParams(url.search);

					if(item.value?.code) searchParams.set('search_q', item.value.code);
					const confCode = searchParams.toString() ? `?${searchParams}` : '';
					window.history.replaceState({}, '', `${url.pathname}${confCode}`);
					emit('confAvailableClass');
				} else {
					return navigateTo('/404/');
				}

				loadingItemData.value = false;
			}

			//offer item
			if(newValue.event === 'selectOffer') {
				loadingItemData.value = true;
				const offerShoppingCartCode = newValue.data?.shopping_cart_code ? newValue.data.shopping_cart_code : confShopingCartCode.value;
				let ep = endpoints.get('_get_hapi_catalog_offer');
				ep = ep.replace('%CODE%', offerShoppingCartCode);

				const res = await useApi(`${ep + webcatalog}`);
				if(res.data?.id) {
					item.value = res.data;
				} else {
					return navigateTo('/404/');
				}

				loadingItemData.value = false;
			}
		}
	);

	// Regenerate thumbnails and reset product services when item is updated (configurable item or seller offer)
	watch(
		item,
		async (newValue) => {
			if(newValue?.id) {
				await imageThumbs();
				resetProductServices();
			}
		}
	);
</script>

<style lang="less" scoped>
	.xxx :deep(img){filter: blur(5px);}

	//tabs
	:deep(.accordion-panel){
		background: var(--white); border-radius: 12px; margin-bottom: 24px;
		@media (max-width: @m){margin-bottom: 0; border-radius: 0;}
		&.active{
			.accordion-panel-header:after{.rotate(180deg);}
			.accordion-panel-body{
				padding-bottom: 24px;
				@media (max-width: @m){padding-bottom: 12px;}
			}
		}
	}
	:deep(.accordion-panel-header){
		display: flex; align-items: center; font-size: 24px; line-height: 1.4; font-weight: 600; color: var(--black); position: relative; cursor: pointer; padding: 17px 24px;
		&:after{.icon-arrow-down(); font: 12px/1 var(--fonti); font-weight: normal; color: var(--black); margin-left: auto;}
		&.no-icon{
			cursor: default;
			&:before{content: none;}
		}

		@media (max-width: @m){
			height: 55px; padding: 15px; font-size: 16px;
			&:before{font-size: 10px;}
			&.active:before{.rotate(180deg);}
		}
	}
	:deep(.accordion-panel-body){
		padding: 0 24px;
		@media (max-width: @m){padding: 0 15px;}
	}
	.cd-tab-more{
		display: inline-flex; font-size: 12px; text-decoration: underline; cursor: pointer; margin-top: 15px;
		@media (min-width: @t){
			&:hover{text-decoration: none;}
		}
	}

	//main
	.cd-bc{
		padding-bottom: 32px;
		
		@media (max-width: @m){display: none;}
	}
	.cd-main{
		display: flex; margin-bottom: 58px; position: relative; gap: var(--elementGap);

		@media (max-width: @m){flex-direction: column-reverse; margin: 0 0 12px;}
	}
	.loading{
		.cd-col2{
			position: relative;
			&:after{.pseudo(auto,auto); inset: 0; background: rgba(255,255,255,0.6); z-index: 1;}
		}
	}

	.companies{
		:deep(a){
			color: var(--textColor); text-underline-offset: 3px; text-decoration-thickness: 1px; position: relative; padding-right: 18px;
			&:after{.icon-link2(); position: absolute; bottom: 3px; right: 0; font: 13px/1 var(--fonti);}
		}
	}
	.cd-col1{
		width: 952px; flex-shrink: 0;

		@media (max-width: @l){width: 750px;}
		@media (max-width: @t){width: 550px;}
		@media (max-width: @m){width: 100%; display: flex; flex-direction: column; gap: 12px;}
	}

	//attribute
	.cd-tab-attributes{
		display: grid; grid-template-columns: 1fr 1fr; gap: var(--elementGap); font-size: 14px; line-height: 1.2; position: relative;
		&:before{.pseudo(1px,auto); background: var(--gray2); position: absolute; left: 50%; top: 0; bottom: 12px; z-index: 1;}

		@media (max-width: @m){
			display: block; gap: 14px; font-size: 12px;
			&:before{content: none;}
		}
	}
	.cd-tab-attribute{
		display: flex;

		@media (max-width: @m){
			margin-bottom: 14px;
			&:last-child{margin-bottom: 0;}
		}
	}
	.cd-tab-attribute-title{width: 50%; flex-shrink: 0; padding-right: 30px; color: #6D6D6D;}
	.cd-tab-attribute-value{width: 50%;}

	//description
	.cd-tab-content-desc{
		font-size: 14px; line-height: 1.5;
		:deep(ul), :deep(ol){margin: 0 0 24px 20px;}
		:deep(h2), :deep(h3), :deep(h4), :deep(h5){padding: 15px 0 10px; font-weight: 600;}
		:deep(iframe), :deep(video){width: 100%;}
		:deep(img){width: auto; height: auto; max-width: 100%; max-height: 100%; border-radius: 8px;;}
		:deep(p:last-child){padding-bottom: 0;}
	}
	.cd-tab-more-desc{margin-top: 24px;}
	.cd-tab-syndicate{
		max-height: 500px; overflow: hidden;
		&.active{max-height: none;}
	}

	//main info
	.cd-col2{
		flex-grow: 1; display: flex; flex-direction: column; gap: 24px;
		@media (max-width: @m){gap: 12px;}
	}

	.cd-brand{
		display: flex; margin-bottom: 6px; font-size: 14px;
		a{text-decoration: underline; color: var(--black);}
		@media (min-width: @t){
			a:hover{text-decoration: none;}
		}
	}
	.cd-title{
		display: block; padding: 0 0 12px; font-size: 20px; line-height: 1.3;
		@media (max-width: @m){font-size: 16px;}
	}
	.cd-badges, .cd-status{padding: 0 0 24px;}

	.cd-info{display: flex; align-items: center; padding-bottom: 15px;}
	.cd-rate-section{display: flex; align-items: flex-end; flex-grow: 1; padding-right: 20px; font-size: 11px; font-weight: 300; color: var(--black);}
	
	.cd-rate-average{
		margin-left: 3px;

		@media (max-width: @m){margin: 0 4px 0 0; font-size: 12px; line-height: 1.2; font-weight: 600;}
	}
	.cd-rate-votes{
		margin-left: 5px; text-decoration: underline; cursor: pointer;
		&:hover{text-decoration: none;}

		@media (max-width: @m){margin-left: 4px;}
	}
	.cd-code{display: block; font-size: 12px; color: var(--gray5);}

	//price
	.price-container{padding-bottom: 24px;}
	.cd-price{
		display: flex; align-items: center; padding: 0 0 5px; gap: 10px; row-gap: 7px;
		.red{color: var(--errorColor);}
		:deep(.current-price){
			font-size: 28px; font-weight: 700;
			:deep(.p-comma){display: none;}
			:deep(.p-d){font-size: 16px; vertical-align: text-top;}
		}
		:deep(.old-price){
			font-size: 14px; padding: 0;
		}

		@media (max-width: @m){align-items: baseline}
	}
	.cd-price-info{
		display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 15px; height: 15px; margin-left: 8px; position: relative;
		&:before{.icon-info(); font: 15px/1 var(--fonti); color: var(--black);}
		&:hover .cd-price-tooltip{display: flex;}
	}
	.cd-price-tooltip{
		display: none; align-items: center; white-space: nowrap; padding: 6px 8px; border-radius: 6px; background: var(--gray3); font-size: 11px; font-weight: normal; color: var(--black); position: absolute; right: -10px; bottom: calc(~"100% - -8px");
		&:before{.pseudo(8px,8px); background: var(--gray3); position: absolute; top: calc(~"100% - 5px"); right: 12px; z-index: 1; .rotate(45deg);}
	}
	.cd-price-installment{
		display: block; font-size: 14px; padding-bottom: 5px; font-weight: bold; display: flex; gap: 7px;
		:deep(p){padding: 0;}
		span{
			font-weight: normal; text-decoration: underline; cursor: pointer;
			&:hover{text-decoration: none;}
		}
	}

	//dynamic price
	.cd-conf-price-label{
		display: none; margin-top: 8px; font-size: 14px; color: var(--black);
		&.active{display: block;}
		:deep(a){
			color: var(--black);
			&:hover{text-decoration: none;}
		}
	}
	.cd-conf-price-section{width: 100%; margin-top: 12px;}
	.cd-conf-price-header{display: flex; align-items: center; margin-bottom: 6px;}
	.cd-conf-price-title{flex-grow: 1; font-size: 14px; color: var(--errorColor);}
	.cd-conf-price-remove{
		display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 20px; height: 20px; background: var(--gray3); border-radius: 100%; font-size: 0; line-height: 0; text-decoration: none; position: relative; .transition(background); cursor: pointer;
		&:before{.icon-x(); font: 10px/1 var(--fonti); color: var(--black); font-weight: 600; text-indent: 1px;}
	}
	.cd-conf-price{
		display: flex; align-items: center; flex-grow: 1;
		span{display: block;}
		.cd-current-price{flex-grow: 1; flex-shrink: 0; color: var(--errorColor);}
	}
	.cd-conf-price-timer{display: flex; align-items: center; flex-shrink: 0; font-size: 15px; color: var(--gray5); position: relative;}
	.cd-conf-price-timer-bottom{
		display: flex; align-items: center;
		.countdown{
			display: flex; flex-shrink: 0;
			:deep(&>span){display: flex; justify-content: center; min-width: 36px; margin-left: 12px; position: relative;}
		}
		:deep(.value){font-size: 28px; font-weight: 600; color: var(--errorColor); position: relative;}
		:deep(.frame){font-size: 8px; font-weight: 400; text-align: center; color: var(--gray5); position: absolute; bottom: 0; top: 100%;}
	}
	.cd-conf-price-note{display: block; width: 100%; margin-top: 22px; font-size: 10px; color: var(--gray5); position: relative;}
	
	@media (max-width: @m){
		.cd-container.info{margin-top: -12px;}
		#cd-specs :deep(.accordion-panel){margin-bottom: 0;}
	}

	//add to cart
	.cd-add-to-cart{display: flex; justify-content: center; padding: 0 0 24px 0;}
	.cd-btn-add{
		width: 100%; height: 60px; border-radius: 30px; font-size: 18px;
		span{
			padding-left: 32px; position: relative;
			&:before{.icon-cart(); font: 21px/1 var(--fonti); color: var(--white); position: absolute; left: 0; top: 1px; .transition(color);}
		}
		@media (min-width: @t){
			&:hover span:before{color: var(--blueDark);}
		}
		
	}

	.cw{
		margin-bottom: 55px; position: relative;
		@media (max-width: @t){padding: 10px 0 0; margin-bottom: 25px;}
		:deep(.swiper){overflow: initial;}
	}

	.related-products{
		padding: 5px 0 50px;
		@media (max-width: @m){
			padding: 15px 15px 12px 15px;
			:deep(.swiper){overflow: visible;}
		}
		.section-header{
			padding-left: 20px;
			@media (max-width: @m){padding: 0;}
		}
		:deep(.swiper-navigation){
			left: auto; bottom: auto; display: flex; gap: 20px; top: -67px; right: 20px;
			@media (max-width: @t){top: -62px;}
			.swiper-button-next{right: auto;}
			.swiper-button{
				position: relative; top: auto; left: auto; transform: none; width: 46px; height: 46px; background: #fff;
				&:before{font-size: 13px; color: var(--gray7);}
				&.swiper-button-disabled{opacity: 0.5;}
			}
		}
		@media (max-width: @l){
			:deep(.wrapper){margin: 0;}
		}
	}
	.m-images{
		display: none;
		@media (max-width: @m){
			display: block; min-height: 280px;
		}
	}

	//energy
	.cd-energy-content{
		display: flex; flex-direction: column; gap: 8px;
	}
	.cd-energy-item{
		display: flex; align-items: center; gap: 10px;
		:deep(img){display: block; width: auto; height: auto; max-width: 40px; max-height: 22px;}
	}

	.age-verification{
		.cd-container, .cd-tab{
			*, &:before, &:after{filter: blur(4px);}
		}
	}

	#safety-info:empty, #related:empty{display: none;}
	@media (max-width: @m){
		.cd-col1{
			#state{order: 1;}
			#cd-specs{order: 2;}
			#energy{order: 3;}
			#desc{order: 4;}
			#manufacturer-desc{order: 5;}
			#safety-info{order: 6;}
			#b2b{order: 7;}
			#related{order: 8;}
			:deep(.feedback){order: 9;}
		}
	}
</style>